import { AntiAuthGuard } from '@23degrees/shared/guards/anti-auth.guard';
import { NoSsrGuard } from '@23degrees/shared/guards/no-ssr.guard';

export const StandAloneRoutes = [
  {
    path: 'oauth/direct/:provider',
    loadChildren: () => import('@23degrees/apps/oauth/pages/oauth-direct-link-page/oauth-direct-link-page.routes'),
    canActivate: [NoSsrGuard],
  },
  {
    path: 'oauth/:provider/:type',
    loadChildren: () => import('@23degrees/apps/oauth/pages/oauth-signup-page/oauth-signup-page.routes'),
    canActivate: [NoSsrGuard],
  },
  {
    path: 'oauth/error',
    loadChildren: () => import('@23degrees/apps/oauth/pages/oauth-signup-page/oauth-signup-page.routes'),
    canActivate: [NoSsrGuard],
    data: {
      type: 'error',
    },
  },
  {
    path: 'connector/:token',
    loadChildren: () => import('@23degrees/atlas/pages/connector-page/connector-page.routes'),
    canActivate: [NoSsrGuard],
  },
  {
    path: 'signup',
    loadChildren: () => import('@23degrees/atlas/pages/login-page/login-page.routes'),
    canActivate: [AntiAuthGuard],
    data: {
      type: 'signup',
    },
  },
  {
    path: 'login',
    loadChildren: () => import('@23degrees/atlas/pages/login-page/login-page.routes'),
    canActivate: [AntiAuthGuard],
    data: {
      type: 'login',
    },
  },
  {
    path: 'confirm/:token',
    loadChildren: () => import('@23degrees/atlas/pages/activation-page/activation-page.routes'),
  },
  {
    path: 'remove/:token',
    loadChildren: () => import('@23degrees/atlas/pages/delete-unverified-page/delete-unverified-page.routes'),
  },
  {
    path: 'reset/:token',
    loadChildren: () => import('@23degrees/atlas/pages/new-password-page/new-password-page.routes'),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('@23degrees/atlas/pages/reset-password-page/reset-password-page.routes'),
  },
  {
    path: 'folder/:slug',
    loadChildren: () => import('@23degrees/atlas/pages/folder-page/folder-page.routes'),
  },
  {
    path: 'connector/:token/:location',
    loadChildren: () => import('@23degrees/atlas/pages/connector-page/connector-page.routes'),
    canActivate: [NoSsrGuard],
  },
  {
    path: 'crawler',
    loadChildren: () => import('@23degrees/atlas/pages/crawler-page/crawler-page.routes'),
    canActivate: [NoSsrGuard],
  },
];
